import { Validator } from 'modules/core';

function validateProject({ title, length, vertical, recordingDueDate }) {
  const titleError = Validator.validateNotEmpty(title, 'Title');
  const verticalError = Validator.validateNotEmpty(vertical, 'Category');
  const recordingDueDateError = Validator.validateTimestampsChronology(new Date(), recordingDueDate, 'project due date');

  let lengthError = null;
  if (length) {
    lengthError = Validator.validateIsFloat(length, 'Length');
  }

  return {
    ...(!!titleError && { title: titleError }),
    ...(!!lengthError && { length: lengthError }),
    ...(!!verticalError && { vertical: verticalError }),
    ...(!!recordingDueDateError && { recordingDueDate: recordingDueDateError }),
  };
}

export default {
  validateProject,
};
